angular.module('NaviaqWebApp').directive('activitiesDeviationLogs', [function () {
    'use strict';

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/report/directives/activities-deviation-logs.html',
        link: function (scope, element, attrs) {
        }
    };
}]);
